/** Señal para recargar listados tras guardar formularios (misma ruta o history POP). */
const STORAGE_KEY = "vitalcasa_refresh_lists";

export function markListsForRefresh() {
  try {
    sessionStorage.setItem(STORAGE_KEY, String(Date.now()));
  } catch (_) {}
}

export function consumeListsRefreshFlag() {
  try {
    const v = sessionStorage.getItem(STORAGE_KEY);
    if (v) sessionStorage.removeItem(STORAGE_KEY);
    return Boolean(v);
  } catch (_) {
    return false;
  }
}
